/**
 * One registry of who currently owns the Escape key across the dark tree.
 *
 * Everything that dismisses on Escape — dropdowns via `useEscapeKey`, Modal and
 * Drawer via `useOverlayStack` — registers here and acts only when it is
 * top-most. A single shared stack is what makes nesting work: a dropdown open
 * inside a Modal must swallow the first Escape on its own, and the Modal take
 * the second. Two independent stacks would each believe they were top-most and
 * both dismiss on one press, because `stopPropagation()` does not stop sibling
 * listeners bound to `document` itself.
 *
 * Registration order is open order, so the last thing opened is top-most.
 */
const _escapeStack: string[] = []

export const pushEscapeOwner = (id: string): void => {
  _escapeStack.push(id)
}

export const removeEscapeOwner = (id: string): void => {
  const idx = _escapeStack.lastIndexOf(id)
  if (idx !== -1) _escapeStack.splice(idx, 1)
}

export const isTopEscapeOwner = (id: string): boolean =>
  _escapeStack[_escapeStack.length - 1] === id
